import "./bootstrap.scss";

import "bootstrap/js/dist/dropdown";
import Modal from "bootstrap/js/dist/modal";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/tab";
import Tooltip from "bootstrap/js/dist/tooltip";
import Popover from "bootstrap/js/dist/popover";
import jQuery from "jquery";

jQuery.fn.tooltip = Tooltip.jQueryInterface;
jQuery.fn.popover = Popover.jQueryInterface;
jQuery.fn.modal = Modal.jQueryInterface;

window.bootstrap = { Modal, Tooltip, Popover };
